import { Locale } from "@/Common/Models/Localization/Locale";
import { ObstetricalFileField, ObstetricalFileRadioButtonField } from "@/Patient/Components/MedicalNote/ObstetricalFile/Control/ObstetricalFileField";
import { ClickableTextRenderOptions } from "@/Patient/Components/MedicalNote/ObstetricalFile/ControlRenderer/ObstetricalFileControlRendererOptions";
import { OntarioObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/Ontario/OntarioObstetricalFileForm";
import { BaseObstetricalFileSubSection, BaseObstetricalFileSubSectionProps } from "../../Common/Subcomponent/BaseObstetricalFileSubSection";

interface BaseOntarioObstetricalFileSubSectionProps extends BaseObstetricalFileSubSectionProps<OntarioObstetricalFileForm> { }

abstract class BaseOntarioObstetricalFileSubSection<TProps extends BaseOntarioObstetricalFileSubSectionProps, TState> extends BaseObstetricalFileSubSection<OntarioObstetricalFileForm, TProps, TState> {
    protected get locale(): Locale { return Locale.en; }

    protected getString(key: string): string {
        return cacheStore.GetString(key, null, this.locale);
    }

    protected renderSimpleField(label: string, field: React.ReactNode, className?: string, unit?: string): JSX.Element {
        return (
            <ObstetricalFileField
                label={label}
                field={field}
                className={className}
                unit={unit}
                locale={this.locale}
            />
        );
    }

    protected renderRadioButtonField(label: string, field: React.ReactNode, className?: string): JSX.Element {
        return (
            <ObstetricalFileRadioButtonField
                label={label}
                field={field}
                className={className}
                locale={this.locale}
            />
        );
    }

    protected renderSubTitle(label: string, className?: string): JSX.Element {
        return (
            <div className="row">
                <div className="col-md-12">
                    <p className={`text-bold f16px ${className ?? ""}`}>{this.getString(label)}</p>
                </div>
            </div>
        );
    }

    protected getClickableTextOptions(id: string, context: string, leftAlign?: boolean): ClickableTextRenderOptions {
        return {
            onClick: show => this.props.onClickableTextChange?.(show ? id : "", show ? context : ""),
            show: this.props.clickableTextId === id,
            context: context,
            leftAlign: leftAlign
        };
    }
}

export { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps };
